import store from '../store/store'

/**
 * 判断是否是业主
 */
const isPermissProprietor = () => {
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (roleName) {
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}

/**
 * 判断是否有添加设备权限
 */
const isPermissAddDevice = () => {
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有删除设备权限
 */
const isPermissDeleteDevice = () => {
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (roleName) {
    case 'OWNER':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有控制设备（开关调光、更新）
 */
const isPermissControlDevice = () => {
  const sysRoleName = store.state.loginUserInfor.roleName
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (sysRoleName) {
    case 'ROOT':
    case 'SALE':
    case 'FAE':
    case 'OAM':
    case 'PARTNER':
    case 'DEALER':
    case 'ENTERPRISE_SALE':
    case 'ENTERPRISE_ADMIN':
      flag = true
      return flag
    default:
      flag = false
      break
  }
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'MEMBER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有下发权限（下发参数、下发策略、设备分组）
 */
const isPermissIssuedDevice = () => {
  const sysRoleName = store.state.loginUserInfor.roleName
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (sysRoleName) {
    case 'SALE':
    case 'FAE':
    case 'OAM':
    case 'PARTNER':
    case 'DEALER':
    case 'ENTERPRISE_SALE':
    case 'ENTERPRISE_ADMIN':
      flag = true
      return flag
    default:
      flag = false
      break
  }
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有修改设备信息权限
 */
const isPermissModifyDeviceInfor = () => {
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有将设备状态设置为不告警的权限
 */
const isPermissModifyDeviceStatus = () => {
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否是有权限管理分组（创建、修改、删除）
 */
const isPermissManagerGroup = () => {
  const sysRoleName = store.state.loginUserInfor.roleName
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (sysRoleName) {
    case 'FAE':
    case 'OAM':
    case 'SALE':
    case 'PARTNER':
    case 'ENTERPRISE_SALE':
    case 'ENTERPRISE_ADMIN':
    case 'DEALER':
      flag = true
      return flag
    default:
      flag = false
      break
  }
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断创建项目权限
 */
const isPermissCreateProject = () => {
  const sysRoleName = store.state.loginUserInfor.roleName
  let flag = false
  switch (sysRoleName) {
    case 'SALE':
    case 'PARTNER':
    case 'CUSTOMER':
    case 'ENTERPRISE_SALE':
    case 'ENTERPRISE_ADMIN':
    case 'ENTERPRISE_CUSTOMER_L1':
    case 'ENTERPRISE_CUSTOMER_L2':
    case 'ENTERPRISE_CUSTOMER_L3':
    case 'TESTER':
    case 'DEALER':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有删除项目的权限
 */
const isPermissDeleteProject = (ownerName) => {
  let flag = false
  if (ownerName === store.state.loginUserInfor.username) {
    flag = true
  }
  const sysRoleName = store.state.loginUserInfor.roleName
  if (sysRoleName === 'PARTNER') {
    flag = true
  }
  return flag
}
/**
 * 判断是否有修改项目信息
 */
const isPermissModifyProjectInfor = () => {
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
    case 'ENTERPRISE_SALE':
    case 'ENTERPRISE_ADMIN':
    case 'ENTERPRISE_CUSTOMER_L1':
    case 'ENTERPRISE_CUSTOMER_L2':
    case 'ENTERPRISE_CUSTOMER_L3':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有权限管理项目策略（创建和修改）权限
 */
const isPermissAddModifyStrategy = () => {
  const sysRoleName = store.state.loginUserInfor.roleName
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (sysRoleName) {
    case 'FAE':
    case 'OAM':
    case 'SALE':
    case 'PARTNER':
    case 'DEALER':
    case 'ENTERPRISE_SALE':
    case 'ENTERPRISE_ADMIN':
      flag = true
      return flag
    default:
      flag = false
      break
  }
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否有权限删除项目策略权限
 */
const isPermissDeleteStrategy = () => {
  const sysRoleName = store.state.loginUserInfor.roleName
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (sysRoleName) {
    case 'FAE':
    case 'OAM':
    case 'SALE':
    case 'PARTNER':
    case 'DEALER':
    case 'ENTERPRISE_SALE':
    case 'ENTERPRISE_ADMIN':
      flag = true
      return flag
    default:
      flag = false
      break
  }
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
/**
 * 判断是否是有权限管理告警（标记为已读）
 */
const isPermissManagerWarn = () => {
  const sysRoleName = store.state.loginUserInfor.roleName
  const roleName = store.state.currentProjectRole
  let flag = false
  switch (sysRoleName) {
    case 'FAE':
    case 'OAM':
    case 'SALE':
    case 'PARTNER':
      flag = true
      return flag
    default:
      flag = false
      break
  }
  switch (roleName) {
    case 'OWNER':
    case 'MANAGER':
    case 'PROPRIETOR':
      flag = true
      break
    default:
      flag = false
      break
  }
  return flag
}
const permiss = {
  isPermissProprietor,
  isPermissAddDevice,
  isPermissDeleteDevice,
  isPermissControlDevice,
  isPermissIssuedDevice,
  isPermissModifyDeviceInfor,
  isPermissModifyDeviceStatus,
  isPermissManagerGroup,
  isPermissCreateProject,
  isPermissDeleteProject,
  isPermissModifyProjectInfor,
  isPermissAddModifyStrategy,
  isPermissDeleteStrategy,
  isPermissManagerWarn
}
export default permiss
